import { headroomPercent, plural, type MediaNode } from './mediaNodes';

/**
 * Weight used against capacity, as text and a bar (never colour alone), with
 * the 70% mark new equipment must stay within and a note above 100%.
 */
export function Occupancy({ node }: { node: MediaNode }) {
  const ratio = node.capacity > 0 ? node.usage.weight / node.capacity : 0;
  const over = ratio > 1;
  // Rounded away from 100 on each side: never "100%" next to "acima da
  // capacidade", nor "100%" for a node still within it.
  const pct = over ? Math.ceil(ratio * 100) : Math.floor(ratio * 100);
  const bar = over ? 'bg-crit' : ratio * 100 > headroomPercent ? 'bg-warn' : 'bg-accent';
  return (
    <div className="w-40">
      <div className="flex items-baseline justify-between gap-2">
        <span className="font-mono text-xs text-fg tabular-nums">{`${String(node.usage.weight)} / ${String(node.capacity)}`}</span>
        <span
          className={`text-2xs tabular-nums ${over ? 'font-medium text-crit' : 'text-fg-subtle'}`}
        >{`${String(pct)}%`}</span>
      </div>
      <div
        aria-hidden="true"
        title={`Equipamento novo só entra até ${String(headroomPercent)}% da capacidade`}
        className="relative mt-1 h-1 rounded-full bg-surface-hover"
      >
        <div
          className={`h-full rounded-full ${bar}`}
          style={{ width: `${String(Math.min(100, pct))}%` }}
        />
        <div
          title={`Equipamento novo só entra até ${String(headroomPercent)}% da capacidade`}
          className="absolute -top-0.5 h-2 w-px bg-fg-muted"
          style={{ left: `${String(headroomPercent)}%` }}
        />
      </div>
      <div className="mt-1 text-2xs text-fg-subtle">
        {plural(node.usage.equipment, 'equipamento', 'equipamentos')}
        {over && <span className="ml-1 font-medium text-crit">· acima da capacidade</span>}
      </div>
    </div>
  );
}
